import { render, staticRenderFns } from "./BusinessGHLReport.vue?vue&type=template&id=493a40bd&scoped=true"
import script from "./BusinessGHLReport.vue?vue&type=script&lang=js"
export * from "./BusinessGHLReport.vue?vue&type=script&lang=js"
import style0 from "./BusinessGHLReport.vue?vue&type=style&index=0&id=493a40bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493a40bd",
  null
  
)

export default component.exports